var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"s-pagination",attrs:{"current-page":_vm.page,"page-size":_vm.pageSize,"total":_vm.total,"background":true,"layout":"total, prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }